import { COINS, VH, VW } from "../../../tiles";
import { openModal } from "../../../ui/containers/Modal";
import { TextButton } from "../../../ui/input/TextButton";
import { ComponentF, createElement } from "../../../ui/ui";
import Colors from "../../Colors";
import { gameData } from "../../GameManager";
import { SpellListModal } from "../book/SpellList";

export const CoinInfo: ComponentF<{
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C) => {
  C.display.drawText(
    C.bounds.x,
    C.bounds.y,
    `${gameData.xp}%c{${Colors.YELLOW_1}}${COINS}%c{}`
  );

  return [
    createElement(
      TextButton,
      { x: 4, y: 0, w: C.bounds.w - 4, h: 1 },
      {
        keys: "Tab",
        title: "Purchase Spells",
        keyLabel: "Tab",
        disabled:
          gameData.selectedSpell ||
          gameData.selectedItem ||
          gameData.target ||
          !gameData.player.alive,
        onClick: () => {
          openModal(
            createElement(SpellListModal, { x: 0, w: VW - 2, y: 0, h: VH - 2 })
          );
        },
      }
    ),
  ];
};
